
export default class VideoChart extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.onEnded = this.onEnded.bind(this);

    // privates
    this._node = this;
    this._video = this._node.querySelector("video");
    this._track = this._node.querySelector(".chart-track");
    this._indicator = this._node.querySelector(".indicator");
    this._raf = null;

    // events
    this._video.addEventListener('ended', this.onEnded);
    this.onTimeUpdate();
  }

  onTimeUpdate() {
    if (this._video.duration) {
      let duration = this._video.duration,
          timestamp = this._video.currentTime,
          percent = (timestamp / duration) * 100,
          anim_percent = percent < 50 ? (percent * 2) : (50 - (percent - 50)) * 2;

      this._indicator.style.transform = `translateY(-${anim_percent}%)`;
    }

    this._raf = requestAnimationFrame(this.onTimeUpdate);
  }

  onEnded() {
    this._video.currentTime = 0;
    this._indicator.style.transform = `translateY(0%)`;

    setTimeout(() => {
      if (this._video && this._video.duration) {
        this._video.play();
      }
    }, 1000);
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    cancelAnimationFrame(this._raf);
    this._video.removeEventListener('ended', this.onEnded);
  }
}
